import React from "react";

export default function LegalLayout({ title, children, testId = "legal-page" }) {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid={testId}>
      <h1 className="font-display text-3xl sm:text-4xl font-black text-stone-800">{title}</h1>
      <p className="text-stone-500 mt-2 text-sm">Dernière mise à jour : 12 février 2026</p>
      <div className="mt-8 bg-white rounded-3xl border border-rose-100 p-8 shadow-sm prose prose-stone max-w-none
                      prose-headings:font-display prose-headings:text-stone-800
                      prose-h2:text-xl prose-h2:font-bold prose-h2:mt-8 prose-h2:mb-3
                      prose-h3:text-lg prose-h3:font-bold prose-h3:mt-5 prose-h3:mb-2
                      prose-p:text-stone-700 prose-p:leading-relaxed
                      prose-li:text-stone-700
                      prose-strong:text-stone-900 prose-a:text-orange-600">
        {children}
      </div>
    </div>
  );
}
